// What a passed stage holds, read-only beneath the path (TX-US-0043, `?stage=`): the fields the
// proposal holds, as the deal's page lists them, the rounds of the approval, and for Contract and
// Execution, which add no fields, where their documents are. A passed stage is shown only with
// the flow on.

import { Link } from 'react-router';

import DealFieldList from './DealFieldList.jsx';
import DealRounds from './DealRounds.jsx';
import { STAGE_LABELS } from './flow.js';

export default function StageHolds({ stage, deal, events, labels, vocabulary }) {
  return (
    <section className="profile-panel stage-holds" aria-label={`What ${STAGE_LABELS[stage]} holds`}>
      <header className="register-header">
        <h3>{STAGE_LABELS[stage]}</h3>
        <Link to={{ search: '' }}>Back to {STAGE_LABELS[deal.stage]}</Link>
      </header>
      <p className="hint">Read only: what {STAGE_LABELS[stage]} holds.</p>

      {stage === 'APPROVAL' && <DealRounds events={events} />}

      {stage === 'PROPOSAL' && (
        <dl className="deal-fields">
          <DealFieldList fields={deal.fields ?? {}} flow labels={labels} vocabulary={vocabulary} />
        </dl>
      )}

      {['CONTRACT', 'EXECUTION'].includes(stage) && (
        <p className="muted">
          {STAGE_LABELS[stage]} adds no fields. Its documents are under Documents, grouped by stage.
        </p>
      )}
    </section>
  );
}
